/** @jsx jsx */
import React from 'react';
//import styled, {css} from 'styled-components';
//import { css, cx } from 'emotion';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

const UL = styled.ul`
  position: static;
  top: 0;
  right: 0;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const LI = styled.li`
  display: inline-block;
  margin: 0px 0px 0px 16px;
  padding: 14px 0px;

  cursor: pointer;

    color: rgba(117,117,117,1);
    :hover {
      opacity: 0.5;
      -webkit-transition: all 0.4s ease 0s; /* For Safari 3.1 to 6.0 */
      transition: all 0.4s ease 0s;
    }  
    transition: all 0.4s ease 0s;
    -webkit-transition: all 0.4s ease 0s; /* For Safari 3.1 to 6.0 */
`;

function Menu() {
  return (
    <div className="Menu">
        <UL>
          <Link to="/"><LI>Home</LI></Link>
          <Link to="/solutions"><LI>Solutions</LI></Link>
        </UL>
    </div>
  );
}

export default Menu;
